import React, { useState } from "react";
import { Button, Form, Select } from "antd";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { convertParamsIdToNumber, onChangeProvince } from "../../../core/utils";
import RangePicker from "../../../components/RangePicker/RangePicker";
import { useHistory, useLocation } from "react-router-dom";
import { parse } from "query-string";

const FilterCreditManagement = (props) => {
  const {
    getCredits,
    provinces,
    cities,
    setCities,
    users,
    form,
    search,
    setSearch,
    getUsers,
    exportCredits,
  } = props;
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const params = parse(location.search);

  const { Option } = Select;

  return (
    <FilterLayout
      search={search}
      setSearch={setSearch}
      onSearch={getCredits}
      placeHolder={"Search with user name"}
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      reportFilter={() => exportCredits()}
    >
      <Form
        form={form}
        name="creditManagementForm"
        initialValues={{
          province_id: convertParamsIdToNumber(params.province_id),
          city_id: convertParamsIdToNumber(params.city_id),
          user_id: convertParamsIdToNumber(params.user_id),
          created_date: [
            params.created_start_date || null,
            params.created_end_date || null,
          ],
        }}
        onFinish={() => {
          getCredits();
          setIsVisible(false);
        }}
        requiredMark={false}
        scrollToFirstError
      >
        <FormWrapper>
          <Form.Item
            name="province_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () => {
                    form.setFieldValue("province_id", value);
                    form.setFieldValue("city_id", null);
                    form.setFieldValue("user_id", null);
                    getUsers(value, null);
                  },
                  setCities
                )
              }
              placeholder={"Province"}
            >
              <Option value={null} name="All Provinces">
                All Provinces
              </Option>
              {provinces?.map((province) => {
                return (
                  <Option key={province.id} value={province.id}>
                    {province.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            className=" sm:w-100 input-size"
            style={{ marginBottom: "10px" }}
            name="created_date"
            colon={false}
          >
            <RangePicker
              className=" border-black-8 w-100"
              currentRange={[
                params.created_start_date || null,
                params.created_end_date || null,
              ]}
              onGetRange={(value) => form.setFieldValue("created_date", value)}
            />
          </Form.Item>

          <Form.Item
            name="city_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              optionFilterProp="name"
              onChange={(value) => {
                form.setFieldValue("city_id", value);
                form.setFieldValue("user_id", null);
                getUsers(form.getFieldValue("province_id"), value);
              }}
              placeholder={"City"}
            >
              <Option value={null} name="All Cities">
                All Cities
              </Option>
              {cities?.map((city) => {
                return (
                  <Option key={city.id} value={city.id}>
                    {city.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="user_id"
            className="input-size sm:w-100 my-5"
            colon={false}
          >
            <Select
              className="border-black-8 mb-16"
              showSearch
              optionFilterProp="name"
              onChange={(value) => form.setFieldValue("user_id", value)}
              placeholder={"Employee"}
            >
              <Option value={null} name="All Employees">
                All Employees
              </Option>
              {users?.map((user) => {
                return (
                  <Option key={user.user.id} value={user.user.id}>
                    {user.user.fullname}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Button
            className="button-red input-size sm:w-100 "
            onClick={() => {
              history.push(window.location.pathname);
              setSearch("");
              setIsVisible(false);
              setTimeout(() => {
                form.resetFields();
                form.submit();
              }, 100);
            }}
          >
            Reset Filters
          </Button>
          <Button
            className="button-secondary  mb-10 sm:w-100 input-size"
            htmlType="submit"
          >
            Filter
          </Button>
        </FormWrapper>
      </Form>
    </FilterLayout>
  );
};

export default FilterCreditManagement;
